import React, { useEffect } from "react";
import { useProjectStore } from "@/stores/projectStore";
import ProjectCard from "@/components/myProjectsComp/ProjectCard";
import { useGetAllProjects, useSetProjectFavorite } from "@/api/ProjetsApi";
import { Project } from "@/types/project";
import SmallLoader from "@/components/SmallLoader";

const ProjectCardList: React.FC = () => {
  const { projects } = useProjectStore();
  const { getAllProjects, loading } = useGetAllProjects();

  const { setProjectFavorite } = useSetProjectFavorite();
  const projectData: Project[] | null = projects;

  const favoriteToggle = () => {
    setProjectFavorite();
  };

  useEffect(() => {
    getAllProjects();
  }, []);

  return (
    <div className="grid grid-cols-4 gap-4 px-4 py-9">
      {loading ? (
        <SmallLoader />
      ) : (
        projectData?.map((project, index) => (
          <ProjectCard
            id={project?.id || ""}
            key={index}
            title={project.title}
            subTitle={project.subTitle ? project.subTitle : "no subTitle"}
            logo={project.logoUrl ? project.logoUrl : "/images/project.png"}
            isFavorited={project.isFavorited}
            toggleFavorite={() => favoriteToggle()}
          />
        ))
      )}
    </div>
  );
};

export default ProjectCardList;
